import React from "react";

// reactstrap components
import { ModalBody, ModalHeader, CardTitle, Button, Table, UncontrolledTooltip, Row, Col, Card, CardBody, CardImg, CardHeader } from "reactstrap";

import { dispTimePeriod, dateFromISO8601, currencyFormat, isAppleWalletSupported } from '_helpers';
import { Link } from "react-router-dom";
import * as moment from 'moment';
import noImage from "assets/img/img-livenyte/LiveNyteNoImage.jpg";
import livenyteIcon from "assets/img/img-livenyte/livenyte_icon.png";
import { useSelector } from "react-redux";
import appleWallet from "assets/img/img-livenyte/appleWallet.svg";
import googleWallet from "assets/img/img-livenyte/googleWallet.svg";

function TicketReceipt(props) {
    const { ticketReceipt, toggle, ticketReceiptHandler, showQRC, pageMode, isEventOwner } = props
    const prefersDark = localStorage.getItem("darkMode") === "true";
    const is_md = useSelector((state) => state.screenSizeData.is_md);
    const is_lg = useSelector((state) => state.screenSizeData.is_lg);

    const now = moment()
    return (
        <>
            <ModalHeader toggle={toggle} className={pageMode ? "px-3" : ""}>
                Ticket Receipt ({ticketReceipt.purchase_id})
                {ticketReceipt && ticketReceipt.hasOwnProperty('phone') && ticketReceipt.phone &&
                    <h6 className="text-left mt-2">
                        <span className="surtitle"> Delivered to <span className="text-primary">{ticketReceipt.phone}</span></span>
                    </h6>
                }
            </ModalHeader>
            <ModalBody className={pageMode ? "pt-0 px-3" : "pt-0"} >
                <CardTitle>
                    <Link
                        target="_blank"
                        to={{
                            pathname: `/e/${ticketReceipt.event_id}`,
                        }}
                    >
                        <h6 className="text-left surtitle mb-2">Event </h6>

                        <h2 className="a title link"> {ticketReceipt.event_name} </h2>
                        <h5 className="surtitle">
                            {dispTimePeriod(ticketReceipt.start_time, ticketReceipt.end_time, ticketReceipt.time_zone, true)}
                        </h5>
                        <div className="text-left  ">
                            <p className="mt-2 mb-3 text-capitalize pb-3">{ticketReceipt.address}</p>
                        </div>
                    </Link>

                </CardTitle>
                <div className="text-left  ">
                    <h6 className="text-left surtitle pt-3"> Transaction</h6>
                    <h4 className="mt-2 mb-2">Purchased on {dateFromISO8601(ticketReceipt.date_sold, ticketReceipt.time_zone, "LLL")}</h4>
                </div>
                {ticketReceipt.refunded === true &&
                    <div className="text-left">
                        <Button size="sm" color={prefersDark ? "spc-white" : "default"} disabled className="title">Transaction Refunded</Button>
                        <br /><br />
                    </div>
                }

                <Table responsive className="table-shopping mb-0">
                    <thead>
                        <tr>
                            <th className="text-left pl-0">Ticket</th>
                            <th className='text-center' > Qty</th>
                            <th className='text-center' >Price</th>
                            <th className="text-right pr-0">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left pl-0">{ticketReceipt.ticket_name}</td>
                            <td className='text-center'>{ticketReceipt.quantity} </td>
                            <td className='text-center'> {currencyFormat(ticketReceipt.country, ticketReceipt.price)}
                            </td>
                            <td className="text-right pr-0"> {currencyFormat(ticketReceipt.country, ticketReceipt.quantity * ticketReceipt.price)} </td>
                        </tr>
                    </tbody>
                </Table>
                <Row>
                    <Col xs={6} className='mr-auto text-left table pr-0'>
                        <th className="text-left px-0" style={{ display: "block" }}>
                            {moment().isBefore(moment(ticketReceipt.start_time).subtract(ticketReceipt.refundable, "day"))}
                            {console.log("Refunds accepted until", dateFromISO8601((moment(ticketReceipt.start_time).subtract(ticketReceipt.refundable, "day")), ticketReceipt.time_zone, "LLL",))}
                            {!ticketReceipt.refunded && ticketReceiptHandler && ticketReceipt.refunded !== true && moment(now).isBefore(ticketReceipt.start_time) && ticketReceipt.is_refundable && moment(ticketReceipt.start_time).subtract(ticketReceipt.refundable, "day") &&
                                <Button outline size="sm" className="text-left" color="danger" onClick={() => ticketReceiptHandler(ticketReceipt.purchase_id)}> Request Refund</Button>
                            }

                            {!ticketReceipt.refunded && isEventOwner &&
                                <Button size="sm" className="text-left" color="danger" onClick={() => ticketReceiptHandler(ticketReceipt.purchase_id)}>Issue Refund</Button>
                            }

                            {ticketReceipt.refunded === true &&
                                <h5 className="title text-left text-primary mt-3"> Transaction Refunded </h5>
                            }
                        </th>
                    </Col>
                    <Col xs={6} className="ml-auto text-right table pl-0">
                        <th className="text-right px-0" style={{ display: "block" }}>
                            <span className style={{ fontWeight: "300", fontSize: "1em", textTransform: "uppercase" }}> + Fees
                                <i className="px-1 fas fa-info-circle surtitle-gray cursor-pointer "
                                    id="fees"
                                />
                                <UncontrolledTooltip
                                    placement="right"
                                    target="fees"
                                    delay={0}>
                                    <div>
                                        <span>
                                            LiveNyte Fee:  {currencyFormat(ticketReceipt.country, ticketReceipt.platform_charge)}
                                            <br /><br />
                                            Payment Processor Fee: {currencyFormat(ticketReceipt.country, ticketReceipt.other_charge)}
                                        </span>
                                    </div>
                                </UncontrolledTooltip>
                                :&nbsp;&nbsp;&nbsp;{currencyFormat(ticketReceipt.country, ((ticketReceipt.platform_charge + ticketReceipt.other_charge)))}

                            </span>
                            <br />
                            <div className='mt-2'>
                                <span style={{ fontWeight: "300", fontSize: "1em", textTransform: "uppercase" }}> + Tax
                                    <i className="px-1 fas fa-info-circle surtitle-gray cursor-pointer "
                                        id="tax"
                                    />
                                    <UncontrolledTooltip
                                        placement="right"
                                        target="tax"
                                        delay={0}>
                                        <div>
                                            {ticketReceipt.tax_breakdown.map((tax, taxIdx) =>
                                                <span key={taxIdx}>
                                                    {tax.tax_rate_details.state}&nbsp;{tax.tax_rate_details.tax_type}&nbsp;{tax.tax_rate_details.rate_type === 'percentage' ? `(${tax.tax_rate_details.rate_amount}%)` : `(${currencyFormat(ticketReceipt.country, tax.tax_rate_details.rate_amount)})`}: {currencyFormat(ticketReceipt.country, tax.amount)}
                                                    <br /><br />
                                                </span>
                                            )
                                            }
                                        </div>
                                    </UncontrolledTooltip>
                                    :&nbsp;&nbsp;&nbsp;{currencyFormat(ticketReceipt.country, ticketReceipt.tax_collected)}

                                </span>
                            </div>

                            <div style={{ marginTop: "15px" }}>
                                <h5 className={ticketReceipt.refunded === true ? "strike-through" : ""} style={{ fontWeight: "600", fontSize: "1.25em", textTransform: "uppercase" }}>
                                    Total: {currencyFormat(ticketReceipt.country, ticketReceipt.quantity * ticketReceipt.price + ticketReceipt.platform_charge + ticketReceipt.other_charge + ticketReceipt.tax_collected)}
                                </h5>
                            </div>
                        </th>
                    </Col>
                </Row>


                <h6 className="text-left surtitle">Refund Policy</h6>
                <div className="text-left mt-2 line-styling">
                    {ticketReceipt.refundable > 1 &&
                        <p className="title text-primary">Refunds are available until {ticketReceipt.refundable} days before the event.</p>}
                    {ticketReceipt.refundable === 1 &&
                        <p className="title text-primary">Refunds are available until {ticketReceipt.refundable} day before the event.</p>}
                    {ticketReceipt.refundable === 0 &&
                        <p className="title text-primary">Refunds are available until the day of the event.</p>}
                    {ticketReceipt.refundable < 0 &&
                        <p className="title text-primary">There are no refunds available for this transaction.</p>}
                    <br />
                </div>
                <h6 className="text-left surtitle"> <i>{ticketReceipt.ticket_name} </i> Information </h6>
                <h4 className="mt-2 text-left">{ticketReceipt.description}</h4>
                {ticketReceipt.refunded === true &&
                    <h3 className="title text-center text-primary mt-3">Transaction Refunded</h3>
                }
                {showQRC && !ticketReceipt.refunded &&
                    <div>
                        <h6 className="text-left surtitle mt-5 mb-3">Your Tickets </h6>
                        {ticketReceipt && ticketReceipt.qrc.map((qrc, key2) =>
                            <Row key={key2} className={"mt-2 mb-6"}>
                                <Col xs={12} md={12} lg={12} key={key2} className=" mx-auto">
                                    <Card className={ticketReceipt.online_only ? "teal-box-shadow-pulse" : "livenyte-box-shadow-pulse"}>
                                        <Row>
                                            <Col lg={4} md={12} className="ml-auto text-center">
                                                <div className={ticketReceipt.online_only ? "bg-teal h-100" : "bg-gradient-primary h-100"}
                                                    style={{ borderRadius: "calc(0.375rem - 1px)" }}>

                                                    <CardBody className="px-0 pb-0 ">
                                                        <Row>
                                                            <Col xs={10} md={10} lg={9} className="mx-auto text-left">
                                                                <CardImg
                                                                    alt="..."
                                                                    src={ticketReceipt.online_only === 0 ? qrc : livenyteIcon}
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = noImage }}
                                                                    top
                                                                    style={{ borderBottomLeftRadius: "calc(0.375rem - 1px)", borderBottomRightRadius: "calc(0.375rem - 1px)" }}
                                                                />
                                                                <h6 className="surtitle text-white pt-3 ">
                                                                    {dateFromISO8601(ticketReceipt.start_time, ticketReceipt.time_zone, "ddd, MMM D")}
                                                                </h6>
                                                                <p className="text-white pt-1">{dateFromISO8601(ticketReceipt.start_time, ticketReceipt.time_zone, "h:mm a ")}</p>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </div>

                                            </Col>
                                            <Col lg={8} md={11} className="mx-auto" >
                                                <Row>
                                                    <Col xs={11} md={11} lg={12} className={is_md ? " mx-auto " : ""}>
                                                        <CardHeader className={"pt-0 border-0  " + (is_md === true ? "text-left px-0" : "text-right")}>
                                                            <CardTitle tag="h3" className="mt-4  mb-2 "> {ticketReceipt.event_name} </CardTitle>
                                                            <hr className="my-3" />
                                                            <h4 className="h3">{ticketReceipt.address}
                                                            </h4>
                                                        </CardHeader>
                                                        <CardHeader className={"pt-2 pb-3 border-0 text-left " + (is_md ? "px-0 " : "")} >
                                                            <h6 className="surtitle">
                                                                <span
                                                                    className="glitch-text glitch-text-animated"
                                                                >
                                                                    {/* {"Ticket | "} */}
                                                                    {ticketReceipt.online_only === 0 &&
                                                                        <span className="text-primary">{"Live Admission Ticket"}</span>
                                                                    }
                                                                    {/* {event.online && ticket.online_only === 0 &&
                                                                            <span className="">{"+ "}</span>
                                                                        } */}
                                                                    {(ticketReceipt.online_only === 1
                                                                        // || (event.online && ticket.online_only === 0)
                                                                    ) &&
                                                                        <span className="text-info">{"Livestream Ticket"}</span>
                                                                    }
                                                                </span>
                                                            </h6>

                                                            <h1 className="line-styling pt-2">
                                                                {ticketReceipt.ticket_name}
                                                            </h1>
                                                            {!ticketReceipt.online_only && isAppleWalletSupported() &&
                                                                <a
                                                                    href={ticketReceipt.pkpasses}
                                                                    onClick={() => console.log("button clicked", ticketReceipt.pkpasses)}
                                                                    className={"btn-app cursor-pointer"}
                                                                >
                                                                    <img
                                                                        style={{ height: "40px", marginRight: "0px", paddingRight: "0px" }}
                                                                        src={appleWallet} className="mt-2 mr-3" alt="Apple Wallet Button" />
                                                                </a>
                                                            }
                                                            {!ticketReceipt.online_only &&
                                                                <a
                                                                    href={ticketReceipt.googlepasses}
                                                                    onClick={() => console.log("button clicked", ticketReceipt.googlepasses)}
                                                                    className={"btn-app cursor-pointer"}
                                                                >
                                                                    <img
                                                                        style={{ height: "40px", marginRight: "0px", paddingRight: "0px" }}
                                                                        src={googleWallet} className="mt-2" alt="Google Wallet Button" />
                                                                </a>
                                                            }
                                                        </CardHeader>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        )}
                    </div>
                }
            </ModalBody >
        </>
    );
}

export default TicketReceipt;
